import { useContext } from "react";
import { StripeContext } from "../store/stripe-context.js";

export default function useStripePayment() {
  return useContext(StripeContext);
}
